import http from './request'

export default {
  // 登录获取验证码
  getPhoneCode (params) {
    return http.get('/zhdc-data-migration/web/h5Verification', {params})
  },
  // 登录
  phoneLogin (params) {
    return http.post('/zhdc-data-migration/web/phoneLogin', params, { headers: { 'Content-Type': 'application/json' } })
  },
  /**
  * @link https://yapi.ideamake.cn/project/1317/interface/api/126140
  * @descripe 根据首页id获取首页详情
  */
  getExhibitionHallHome (id) {
    return http.get(`/config-manager/applet/exhibition/home-page/${id}`)
  },
  // 获取城市id
  getCityId (params) {
    return http.get('/public-tools/areas/get-cityId', {params})
  },
  // 获取热门直播
  getPopularLiveBroadcast (params) {
    return http.get('/content-server/applets-live/v2', { params })
  },
  // 获取精选好房
  getChoiceProjectList (params) {
    return http.get('project-server-v1//project/general', { params })
  },
  // 获取首页banner
  getBanners (params) {
    return http.get('/content-server/banner/v2', { params })
  },
  // 获取首页城市精品
  getCityBoutique (params) {
    return http.get('/content-server/banner/v2', { params })
  },
  // 首页 - 热门活动
  getActivities (params) {
    return http.get('/activity-cloud/activity/general', { params })
  },
  // 获取项目列表
  getProjectList (params) {
    return http.post('/project-server-v1/project/get/v2', params, { headers: { 'Content-Type': 'multipart/form-data' } })
  },
  // 根据城市获取区域数据列表
  getAreaListZH (params) {
    return http.get('/project-server-v1/project/getProjectAreaStatistics', { params })
  },
  // 生成小程序二维码
  getWxaCode (url) {
    const params = {
      type: 'ACTIVITY_SKIP',
      wxUrl: 'pages/redirect/index',
      url
    }
    return http.post('/spread-server/applet-short-url/qrcode', params, { headers: { 'Content-Type': 'multipart/form-data' } })
  },
  /**
   * @link https://yapi.ideamake.cn/project/1317/interface/api/126284
   * @descripe 通过城市id获取首页
   */
  getExhibitionHallHomeId (cityId) {
    return http.get(`/config-manager/applet/exhibition/home-page/city?cityId=${cityId}`)
  },
  getCityList () {
    return http.get('/config-manager/applet/exhibition/home-page/list')
  },
  getHotCityList () {
    return http.get('/config-manager/applet/exhibition/home-page/hot/list')
  },
   // 获取楼盘头条分类
  getHeadLineDictList (params) {
    return http.get('/project-server-v1/zh/applet/project-headline/getAppletHeadLineDictList', { params })
  },
  // 获取楼盘头条列表
  getHeadLineList (params) {
    return http.get('/project-server-v1/zh/applet/project-headline/selectAppletAllHeadLine', { params })
  },
  // 线上展厅 - 项目详情
  getProjectDetail (projectCode) {
    return http.get(`/project-server-v1/project/detail/${projectCode}`)
  },
  // 首页 - 房产项目详情 - 楼盘动态
  getDynamic (params) {
    return http.get(`/project-business/project-dynamic`, { params })
  },
  // 线上展厅 - 项目周边信息配置
  getProjectArund (params) {
    return http.get(`/project-business/project-around/get-around-no-map`, { params })
  },
  // 线上展厅 - 项目周边信息配置
  getProjectArundList (params) {
    return http.get(`/project-business/project-around/get-around`, { params })
  },
  // 首页 - 房产项目详情 - 置业顾问
  getAdvisers (params) {
    return http.get(`/seller-server/users`, { params })
  },
  // 根据项目代号获取是否存在官方咨询顾问(有手机号码的)
  getChatOfficialUser (projectCode) {
    return http.get(`/seller-server/user-official-consult?projectCode=${projectCode}`)
  },
  // 首页 - 访客id
  getVisitorId (projectCode, shareId) {
    return http.get(
      `/customer-server/visitors/code`,
      { params: {projectCode, shareId, defaultCognitionType: 1} },
    )
  },
  // 名片展示页 - 个人信息
  getBusinessCard (shareId) {
    return http.get(`/visiting-card/users/cards/index/information`, { params: {shareId} })
  },
}

